import(/* webpackMode: "eager" */ "/home/athakai-de/htdocs/de.athakai.com/app/error.js");
